<div class="chat-container" [ngClass]="{ 'dark-theme': customizer.isDark(), 'light-theme': !customizer.isDark() }">

  <div class="users-list">
    <input type="text" class="search-input" placeholder="Rechercher un utilisateur..." [(ngModel)]="searchTerm" />

  <ul>
    <li *ngFor="let user of filteredUsers()"
        (click)="onRecipientSelected(user.id)"
        [class.selected]="user.id === recipientId"
        tabindex="0"
        role="button"
        class="user-item"
        (keydown.enter)="onRecipientSelected(user.id)">

      <div class="user-circle">{{ user.name.charAt(0) }}</div>
      <div class="user-info">
        <div class="username">{{ user.name }}</div>
        <span *ngIf="shouldShowUnseenIndicator(user.id)" class="unseen-indicator">
          🔴 Nouveau message
        </span>
        <div class="last-message" *ngIf="lastMessagesByUser[user.id] as lastMsg">
          <small>
            <strong>{{ lastMsg.senderId === currentUserId ? 'Vous :' : user.name + ' :' }}</strong>
            {{ lastMsg.content | slice:0:30 }} <!-- Aperçu -->
            <span class="timestamp">{{ lastMsg.timestamp | date:'shortTime' }}</span>
          </small>

        </div>

        <div *ngIf="!lastMessagesByUser[user.id]">
          <small>Aucun message avec {{ user.name }}</small>
        </div>
      </div>
    </li>
  </ul>

  </div>

  <!-- Zone de discussion -->
  <div class="chat-box" *ngIf="recipientId !== null">
    <h3 style="font-size: 18px;">{{ recipientUsername }}</h3>
<div class="messages" #messagesContainer>
  <div *ngFor="let msg of messages"
       [class.my-message]="msg.sender?.id === currentUserId"
       [class.other-message]="msg.sender?.id !== currentUserId">
    <div class="message-content">
      <p>{{ msg.content }}</p>    
      <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
              (click)="deleteMessage(msg.id)"
              style="border: none; background-color: transparent;font-size: 10px;">
        <i class="material-symbols-outlined text-danger" style="font-size: 15px;">
          delete
        </i>
      </button>
      <span class="timestamp">{{ msg.timestamp | date:'shortTime' }}</span>
    </div>
  </div>
</div>


    <div class="message-input">
      <textarea [(ngModel)]="messageContent" placeholder="Écrire un message..." rows="3"></textarea>
      <button (click)="sendMessage()" style="font-size: 18px;">Envoyer</button>
    </div>
  </div>

  <!-- Message si aucun utilisateur sélectionné -->
  <div *ngIf="recipientId === null" class="no-recipient">
    <p>Veuillez sélectionner un utilisateur pour démarrer une conversation.</p>
  </div>

</div>